
import React, { useState, useEffect } from 'react';
import './search-bar.css';

function SearchBar({ 
  onSearch, 
  placeholder = 'Search cryptocurrencies...', 
  className = '',
  debounceMs = 300,
  disabled = false 
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onSearch) {
        onSearch(searchTerm);
      }
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [searchTerm, debounceMs, onSearch]);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClear = () => {
    setSearchTerm('');
    if (onSearch) {
      onSearch('');
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div className={`search-bar ${isFocused ? 'focused' : ''} ${disabled ? 'disabled' : ''} ${className}`}>
      <div className="search-input-container">
        <div className="search-icon">
          🔍
        </div>
        
        <input
          type="text"
          className="search-input"
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleInputChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={disabled}
          autoComplete="off"
          spellCheck="false"
        />
        
        {searchTerm && (
          <button
            className="clear-button"
            onClick={handleClear}
            type="button"
            aria-label="Clear search"
          >
            ✕
          </button>
        )}
      </div>
      
      {searchTerm && (
        <div className="search-info">
          Searching for "{searchTerm}"
        </div>
      )}
    </div>
  );
}

export default SearchBar;
